import React, { useState, useEffect, useContext } from "react";
import { LanguageContext } from "./context/LanguageProvider";
import LanguageModal from "./components/LanguageModal.jsx";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { Features } from "./components/features";
import { Article } from "./components/article";
import { ImageHorizontalList } from "./components/imagehorizontalist";
import { Contact } from "./components/contact";
import SmoothScroll from "smooth-scroll";
import { CarouselBanner } from "./components/carouselbanner";
import { CarouselGallery } from "./components/carouselgallery";
import galleryData from "./data/coffee_gallery.json";
import "./App.css";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const CoffeePage = () => {
  const [openModal, setOpenModal] = useState(false);
  const { language, translations } = useContext(LanguageContext);
  const [pageData, setPageData] = useState(translations);

  useEffect(() => {
    setPageData(translations);
  }, [translations]);

  return (
    <div>
      <Header>
        <Navigation setOpenModal={setOpenModal} language={language} translations={translations}/>
      </Header>
      <CarouselBanner data={pageData.CoffeePageCarouselBanner}/>
      <Features data={pageData.CoffeePageProducts} anchor="products"/>
      <Article data={pageData.CoffeePageOurCoffee} anchor="about"/>
      {/* <Gallery data={pageData.CoffeePageGallery} /> */}
      {/* <CarouselGallery data={galleryData.Images} /> */}
      <ImageHorizontalList data={pageData.SupportedBy} />
      <Contact data={pageData.Contact} />
      <LanguageModal isOpen={openModal} setModalOpen={setOpenModal} />

    </div>
  );
};

export default CoffeePage;
